import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import NotificationVariableServices from "./NotificationVariable.services";
toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNotificationVariable = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_VARIABLE,
      payload: true,
    });
    const resp = await NotificationVariableServices.getNotificationVariable(filters);
    dispatch({
      type: actions.GET_NOTIFICATION_VARIABLE,
      payload: {
        notificationVariables: resp.data.data,
        notificationVariablesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_VARIABLE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_VARIABLE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_VARIABLE,
      payload: false,
    });
  }
};


